import { call, put, takeLatest } from 'redux-saga/effects';
import { CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON, CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON_SUCCESS } from './../actions/editOrder';
import hanldeException from './../services/handleException';
import { channelOrderItemOfOrderFromAmazon } from './../utils/orders';

export function* channelOrderItemOfOrderFromAmazonSaga() {
    yield takeLatest(CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON, channelOrderItemOfOrderFromAmazonHandle)
}

function* channelOrderItemOfOrderFromAmazonHandle(action) {
    try {
        const response = yield call(channelOrderItemOfOrderFromAmazon, action.payload)

        if (response.data.code === 10001) {
            yield put({ type: CHANNEL_ORDER_ITEM_OF_ORDER_FROM_AMAZON_SUCCESS, payload: response })
        } else {
            hanldeException(response)
        }
    } catch (error) {
        hanldeException(error)
    }
}

export default channelOrderItemOfOrderFromAmazonSaga


// WEBPACK FOOTER //
// ./src/sagas/channelOrderItemOfOrderFromAmazonSaga.js